import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types'
import { requestSalesChannelsList } from 'requests/sales-channels';
import { ORDER_STATUSES, ORDER_PAYMENT_STATUSES } from 'constants/order-status';
import Search from '@material-ui/icons/Search'
import { Button } from 'ui-components/Button'
import { SelectCustomer } from 'components/SelectCustomer';
import {
  InputForm,
  SelectForm,
} from 'components/Form/components'
import { FiltersInputs, FiltersSelects, ButtonContainer } from './styles';

const INITIAL_FILTERS = {
  status: {},
  channel: {},
  paid: {},
}

export default function SearchForm({ onSearch }) {
  const [filters, setFilters] = useState(INITIAL_FILTERS)
  const [channels, setChannels] = useState([])

  const getChannels = useCallback(async () => {
    const response = await requestSalesChannelsList()
    setChannels(response.data?.map((channel) => ({
      label: channel.attributes.name,
      value: channel.id,
    })))
  }, [])

  useEffect(() => {
    getChannels()
  }, [getChannels])

  const handleChange = (evt) => {
    const { value, name } = evt.target
    setFilters({
      ...filters,
      [name]: value,
    })
  }

  const handleChangeSelect = ({ name, value, options = [] }) => {
    const option = options.find((item) => item.value === value)

    setFilters({
      ...filters,
      [name]: option || {},
    })
  }

  const handleSelectCustomer = (customer) => {
    setFilters({
      ...filters,
      customer_id: customer.customer_id,
    })
  }

  const handleSearch = () => {
    const params = {
      ...filters,
      channel: filters.channel.value,
      paid: filters.paid.value,
      status: filters.status.value,
    }

    onSearch(params)
  }

  return (
    <>
      <FiltersInputs>
        <InputForm
          fullWidth
          label="Número"
          value={filters.code}
          name="code"
          onChange={handleChange}
        />

        <InputForm
          fullWidth
          label="Data"
          type="date"
          name="date"
          onChange={handleChange}
          value={filters.date}
        />

        <SelectCustomer onSelectCustomer={handleSelectCustomer} />
      </FiltersInputs>

      <FiltersSelects>
        <SelectForm
          name="channel"
          options={channels}
          value={filters.channel}
          label="Canal"
          onChange={(item) => handleChangeSelect({
            ...item,
            options: channels,
          })}
        />

        <SelectForm
          name="status"
          options={ORDER_STATUSES}
          value={filters.status}
          label="Status"
          onChange={(item) => handleChangeSelect({
            ...item,
            options: ORDER_STATUSES,
          })}
        />

        <SelectForm
          name="paid"
          options={ORDER_PAYMENT_STATUSES}
          value={filters.paid}
          label="Pagamento"
          onChange={(item) => handleChangeSelect({
            ...item,
            options: ORDER_PAYMENT_STATUSES,
          })}
        />

        <ButtonContainer>
          <Button
            type="submit"
            buttonType="icon"
            size="small"
            onClick={handleSearch}
          >
            <Search />
          </Button>
        </ButtonContainer>
      </FiltersSelects>
    </>
  )
}

SearchForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
}
